import { DOCUMENT_EXTENSIONS, DOCUMENT_REQUEST_LOCATION, IDocumentRequest } from '../../../models/utilities/document-request';
import { API_METHODS } from '../../../models/utilities/type-models';
import { ApiEndpoints } from '../../../utils/app-constants';
import { AppUtils } from '../../../utils/app-utils';
import { toCondensedDateTimeSeconds } from '../../../utils/date-utils';
import { MetricsSearchFilters } from '../metrics-search-filters';

export class MetricsPickupExport implements IDocumentRequest {

    public filename : string = '';
    public fileExtension : DOCUMENT_EXTENSIONS = 'xlsx';
    public openInTab : boolean = false;
    public url : string = ''; 
    public reportLocation : DOCUMENT_REQUEST_LOCATION = 'api';
    public methodType : API_METHODS = 'GET';

    constructor(filters : MetricsSearchFilters) {
        
        this.url = AppUtils.convertFiltersToUrl(ApiEndpoints.PRODUCTION_METRICS_ORDERS_EXPORT, filters);
        this.filename = `PlanningOrders_${ toCondensedDateTimeSeconds(new Date()) }`;
    }
}
